import { SxProps, Theme } from '@mui/material';

import Icon from 'components/@icons/Icon';

interface Props {
  sx?: SxProps<Theme>;
  height?: number;
  width?: number;
  color?: string;
}

const LogoNofomo = ({
  color = 'common.white',
  height = 24,
  width = 58,
  sx,
}: Props) => {
  return (
    <Icon
      name="LogoNofomo"
      height={height}
      width={width}
      color={color}
      sx={Array.isArray(sx) ? sx : [sx]}
    />
  );
};
export default LogoNofomo;
